import React from 'react'

export default function Footer() {
  return (
    <>
    <footer className="page-footer font-small blue">


<div className="footer-copyright text-center py-3">© 2022 Copyright:
  <a style={{color:'blue'}}> Powered by SNIPL</a>
</div>


</footer>
    </>
  )
}
